<div class="step-dialog-shell" [class.sequential-mode]="headerMode === 'sequential'" [class.tabs-mode]="headerMode === 'tabs'">
  <div class="dialog-header" *ngIf="shouldRenderHeader">
    <div class="header-left" [class.without-icon]="!shouldShowHeaderIcon">
      <div class="icon-badge" *ngIf="shouldShowHeaderIcon">
        <mat-icon>{{ headerIcon }}</mat-icon>
      </div>

      <div class="header-text" *ngIf="hasHeaderText">
        <h2 class="title" *ngIf="title">{{ title }}</h2>
        <div class="subtitle" *ngIf="subtitle">{{ subtitle }}</div>
      </div>
    </div>

    <button
      *ngIf="showClose"
      type="button"
      class="close-btn"
      mat-icon-button
      aria-label="Close dialog"
      (click)="onCloseClick()"
      [disabled]="disableClose"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Header row -->
  <div class="steps" *ngIf="headerMode === 'sequential'; else tabHeader">
    <button
      type="button"
      class="step"
      *ngFor="let s of controller.steps; let i = index"
      [class.active]="controller.stepIndex === i"
      [class.complete]="isStepComplete(i)"
      [class.locked]="isStepLocked(i)"
      (click)="onStepSelect(i)"
      [disabled]="isStepLocked(i)"
    >
      <div class="bubble">
        <mat-icon *ngIf="isStepComplete(i); else stepNumber">check</mat-icon>
        <ng-template #stepNumber>{{ i + 1 }}</ng-template>
      </div>
      <div class="label">{{ s.label }}</div>
      <mat-icon class="chev" *ngIf="i < controller.steps.length - 1">chevron_right</mat-icon>
    </button>
  </div>

  <ng-template #tabHeader>
    <div class="tab-steps" role="tablist" aria-label="Steps">
      <button
        type="button"
        class="tab"
        role="tab"
        *ngFor="let s of controller.steps; let i = index"
        [attr.aria-selected]="controller.stepIndex === i"
        [class.active]="controller.stepIndex === i"
        [class.locked]="isStepLocked(i)"
        [disabled]="isStepLocked(i)"
        (click)="onStepSelect(i)"
      >
        <mat-icon *ngIf="s.icon" class="tab-icon">{{ s.icon }}</mat-icon>
        <span class="tab-label">{{ s.label }}</span>
        <span class="tab-badge" *ngIf="controller.getStepBadgeCount(s, i) as badgeCount">{{ badgeCount }}</span>
      </button>
    </div>
  </ng-template>

  <mat-divider class="header-divider" *ngIf="shouldRenderHeaderDivider"></mat-divider>

  <!-- Body -->
  <div class="dialog-body">
    <ng-container *ngIf="currentStepTemplate; else missingStep" [ngTemplateOutlet]="currentStepTemplate"></ng-container>

    <ng-template #missingStep>
      <div class="missing">No template provided for step {{ controller.stepIndex + 1 }}.</div>
    </ng-template>
  </div>

  <mat-divider class="footer-divider"></mat-divider>

  <!-- Footer -->
  <div class="dialog-footer">
    <ng-container *ngIf="currentFooterTemplate; else defaultFooter" [ngTemplateOutlet]="currentFooterTemplate">
    </ng-container>

    <ng-template #defaultFooter>
      <!-- Sequential default footer -->
      <ng-container *ngIf="headerMode === 'sequential'; else tabsFooter">
        <button mat-stroked-button class="shell-btn" (click)="controller.back()" [disabled]="controller.stepIndex === 0">
          <mat-icon class="btn-icon-left">chevron_left</mat-icon>
          Back
        </button>

        <button
          class="shell-btn shell-btn-primary"
          mat-raised-button
          color="primary"
          (click)="controller.next()"
          [disabled]="controller.stepIndex === controller.steps.length - 1"
        >
          Next
          <mat-icon class="btn-icon">chevron_right</mat-icon>
        </button>
      </ng-container>

      <!-- Tabs default footer -->
      <ng-template #tabsFooter>
        <div class="footer-left tabs-footer-left">
          <button mat-stroked-button class="shell-btn" (click)="controller.back()" [disabled]="controller.stepIndex === 0">
            <mat-icon class="btn-icon-left">chevron_left</mat-icon>
            {{ previousLabel }}
          </button>

          <button
            class="shell-btn"
            mat-stroked-button
            (click)="controller.next()"
            [disabled]="controller.stepIndex === controller.steps.length - 1"
          >
            {{ nextLabel }}
            <mat-icon class="btn-icon">chevron_right</mat-icon>
          </button>
        </div>

        <div class="footer-right tabs-footer-right">
          <button *ngIf="showCancel" mat-stroked-button class="shell-btn" (click)="onCancelClick()" [disabled]="disableCancel">
            {{ cancelLabel }}
          </button>

          <button
            *ngIf="showPrimary"
            class="shell-btn shell-btn-primary"
            mat-raised-button
            color="primary"
            (click)="onPrimaryClick()"
            [disabled]="disablePrimary"
          >
            {{ primaryLabel }}
          </button>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
